import './index.scss';

import React, { useContext, } from 'react';
import { useTranslation, } from 'react-i18next';
import { LocalizedLink, } from 'gatsby-theme-i18n';

import { ThemeContext, } from '../theme';
import Page from '../components/Page';
//import { NavSecondPageBackTo } from "../components/elements/NavSecondPage";



export default function NotFoundPage() {
  const { theme, } = useContext(ThemeContext);
  const { i18n, t, } = useTranslation('404');

  const imagePrefix = "https://ivannikov.pro/images";
  const imageUrl = imagePrefix + `/ivannikov.pro_${i18n.language}.jpg`;

  return (
    <Page
      title={t('Page not found')}
      description={t('Page not found')}
      keywords={''}
      meta={[
        { name: 'image', content: imageUrl, },
        { name: 'og:image', property: 'og:image', content: imageUrl, },
        { name: 'twitter:image', property: 'twitter:image', content: imageUrl, },
      ]}
    >
      <div id={`front ${theme}`} style={{ minHeight: '95vh', marginTop: '100px', }}>
        <main className='main'>
          <section id='home' className='section section-start'>
            <div className='container'>
              <h1>{t('Page not found')}</h1>
              <p>
                Sorry 😔, we couldn’t find what you were looking for.
                <br />
                {process.env.NODE_ENV === 'development' ? (
                  <>
                    <br />
                    Try creating a page in <code>src/pages/</code>.
                    <br />
                  </>
                ) : null}
                <br />
                <LocalizedLink to='/'>{t("To Home Page")}</LocalizedLink>.
              </p>
            </div>
          </section>
        </main>
      </div>
    </Page>
  );
}
